import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';
import { PAD_ANGLE } from '../../constants.js';
import type { InternalSliceData } from '../../types/internal/pie-chart.js';
import { groupSubpixelSlices } from '../../utils/group-subpixel-slices.js';

export const useSetVisibleSlicesState = () => {
  const setState = useSetState();

  const setVisibleSlicesState = useCallback(
    (slices: InternalSliceData[]) => {
      const filteredSlices = groupSubpixelSlices(slices, PAD_ANGLE);
      setState((prev) => {
        return {
          ...prev,
          visibleSlices: filteredSlices,
        };
      });
    },
    [setState],
  );

  return setVisibleSlicesState;
};
